import _objectWithoutProperties from "/Users/p.balahonov/IdeaProjects/remembergood/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
export var triggerGA = function triggerGA(option) {
  var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _option$command = option.command,
      command = _option$command === void 0 ? 'event' : _option$command,
      type = option.type,
      restOptions = _objectWithoutProperties(option, ["command", "type"]);

  var options = {};

  if (debug) {
    window.console.info("ga: ".concat(option.type), options);
    return;
  }

  if (typeof window.ga !== 'undefined') {
    var location = option.location || window.location.href;

    if (option.referrer) {
      window.ga('set', 'referrer', option.referrer);
    }

    if (location) {
      window.ga('set', 'location', location);
    }

    window.ga(command, type, restOptions);
  }
};